import React from 'react';
import * as PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../img/wb-logo.svg';
import './Loading.sass';
import { faSpinnerThird } from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import Spinner from 'react-bootstrap/Spinner';

export const LoadingFullScreen = ({ title, message }) => (
  <div key="loading-full" className="loading-fullscreen">
    <div className="inner">
      <img src={process.env.PUBLIC_URL + '/img/wbl_logo_box.png'} alt="WhiteBox Learning" width="72" height="72" />
      <br />
      <h4 className="d-flex align-items-center">
        <Spinner animation="border" size="md" className="me-3" /> {title}
      </h4>
      {message.length > 0 && <p>{message}</p>}
    </div>
  </div>
);
LoadingFullScreen.defaultProps = {
  title: 'Loading...',
  message: '',
};
LoadingFullScreen.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};

export const LoadingModal = ({ title, message, bgColor }) => (
  <div
    key="loading-modal"
    className="loading-modal"
    style={{ backgroundColor: bgColor }}
  >
    <div className="inner">
      <FontAwesomeIcon icon={faSpinnerThird} spin size="4x" />
      {title.length > 0 && (
        <div>
          <hr />
          <h4>{title}</h4>
        </div>
      )}
      {message.length > 0 && <p>{message}</p>}
    </div>
  </div>
);
LoadingModal.defaultProps = {
  title: '',
  message: '',
  bgColor: 'rgba(0,0,0,0.5)',
};
LoadingModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  bgColor: PropTypes.string,
};

export const Loading = ({ showIcon, title, message }) => (
  <div key="loading" className="loading">
    <div className="inner">
      {showIcon === true && (
        <FontAwesomeIcon icon={faSpinnerThird} spin size="4x" />
      )}
      {title.length > 0 && <h4>{title}</h4>}
      {message.length > 0 && <p>{message}</p>}
    </div>
  </div>
);
Loading.propTypes = {
  showIcon: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string,
};
Loading.defaultProps = {
  showIcon: true,
  title: '',
  message: '',
};
